<template>
  <div id="canvas" class="pt-page pt-page-2 pt-page-current" >
    <div class="home-container">
      <a class="logo" href="/">OM</a>
      <div class="container">
        <div class="home-heading-container">
          <h1>Ollie Murphy</h1>
          <h2>Full Stack Developer</h2>
        </div>
        <ul class="main-nav">
          <li>
            <router-link to="/portfolio">Portfolio</router-link>
          </li>
          <li>/</li>
          <li>
            <router-link to="/about">About Me</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
